export const Terms = {
  template: "#terms"
};
